import React from "react";
import { FaFacebookF, FaLinkedinIn, FaMediumM, FaWhatsapp } from "react-icons/fa";
import bgImage from "../assets/images/asdflobg.jpg"; // Replace with your actual image file
import PlatformFeatures from "../components/PlatformFeatures";
import SignupModal from "../components/SignupModal";
import useAuthUser from "../hooks/useAuthUser";
// import useProfles from "../hooks/useProfles"; // Removed: hook does not exist
import { signOut } from "firebase/auth"; // Keep for now, might be removable if Header handles all sign outs
import { auth } from "../firebase"; // Keep for now
import { useNavigate } from "react-router-dom";
// import LogoWithSlogan from "../components/LogoWithSlogan"; // No longer needed here
import Header from "../components/Header"; // Added shared Header component

import Footer from "../components/Footer";
import ReferAndShareCTA from "../components/ReferAndShareCTA";
import ReferralModal from "../components/ReferralModal";
import MchatSection from "../components/MchatSection";
import BlogSection from "../components/BlogSection";

export default function Landing() {
  const user = useAuthUser();
  const [referralModal, setReferralModal] = React.useState({ open: false, role: null });
  // const userRole = user ? 'parent' : null; // userRole is determined within Header via useUserRole
  const navigate = useNavigate();
  
  // handleSignOut might be removable if all sign-out actions are through the shared Header
  // For now, keep it if there are other sign-out mechanisms on this page, otherwise, it's redundant.
  // const handleSignOut = async () => { 
  //   await signOut(auth);
  //   navigate('/');
  // };

  // handleDashboardNav is also handled by the shared Header component.
  // const handleDashboardNav = async () => { ... }; 

  const [showTerms, setShowTerms] = React.useState(false);
  const [showSignupModal, setShowSignupModal] = React.useState(false);
  const [signupRole, setSignupRole] = React.useState(null);
  // const [showMobileNav, setShowMobileNav] = React.useState(false); // Handled by Header.jsx

  const handleOpenSignup = (role) => {
    setSignupRole(role);
    setShowSignupModal(true);
  };
  const handleCloseSignup = () => {
    setShowSignupModal(false);
    setSignupRole(null);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Use the shared Header component */}
      <Header onLoginButtonClick={() => handleOpenSignup(null)} />

      {/* Hero Section */}
      <section className="relative flex flex-col items-center justify-center min-h-[80vh] w-full text-center px-4 py-16 overflow-hidden">
        {/* Background Video Container */}
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 object-cover"
            style={{ filter: 'brightness(0.8)' }}
            aria-label="Background video showing happy children with therapists"
          >
            <source src={`${process.env.PUBLIC_URL}/assets/videos/asdflovideo.mp4`} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-black/40 z-0" />
        {/* Decorative gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-white/10 z-0" />
        {/* Hero Content */}
        <div className="relative z-10 flex flex-col items-center justify-center w-full">
          <h1 className="font-heading text-4xl md:text-6xl font-bold leading-tight mb-4 text-white drop-shadow-lg">
            Empowering Neurodiverse Growth through Inclusive Tech
          </h1>
          <p className="font-sans text-lg md:text-xl mb-8 max-w-3xl mx-auto opacity-90 text-white drop-shadow">
            Helping parents, therapists & child development centers connect with care.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4">
            <button
              onClick={() => navigate('/free-assessment')}
              className="px-8 py-3 rounded-lg bg-sky-500 hover:bg-sky-700 text-lg font-extrabold text-white shadow-xl border-2 border-sky-200 transition focus:outline-none focus:ring-2 focus:ring-sky-400 animate-bounce"
              style={{ minWidth: 260 }}
              aria-label="Take the free M-CHAT autism screening test"
            >
              🩺 Take the Free M-CHAT Autism Screening
            </button>
          </div>
          {/* Animated Down Arrow to Features */}
          <div className="flex flex-col items-center mt-8">
            <button
              aria-label="Scroll to features"
              onClick={() => {
                const el = document.getElementById('features');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-transparent border-none animate-bounce focus:outline-none"
              style={{ outline: 'none', border: 'none' }}
            >
              <svg className="w-12 h-12 text-white drop-shadow-lg" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
              <span className="sr-only">Scroll to features</span>
            </button>
          </div>
        </div>
      </section>

      {/* M-CHAT Dedicated Section */}
      <MchatSection onStart={() => navigate('/free-assessment')} />
      
      <ReferralModal open={referralModal.open} onClose={() => setReferralModal({ open: false, role: null })} defaultRole={referralModal.role} />

      {/* Features Section */}
      <PlatformFeatures onOpenSignup={handleOpenSignup} />

      {/* Video Section */}
      <section className="w-full py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Experience the ASDflo Difference
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              See how our platform transforms lives through personalized care and support
            </p>
          </div>
          <div className="max-w-4xl mx-auto rounded-xl overflow-hidden shadow-2xl bg-black">
            <video
              id="asdflo-video"
              controls
              playsInline
              preload="metadata"
              className="w-full h-auto max-h-[80vh]"
              poster={`${process.env.PUBLIC_URL}/assets/images/video-poster.jpg`}
              aria-label="ASDflo platform demonstration video"
            >
              <source src={`${process.env.PUBLIC_URL}/assets/videos/asdflovideo.mp4`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Refer & Share CTA - Positioned above WhatsApp button */}
      <ReferAndShareCTA 
        onReferClick={() => setReferralModal({ open: true, role: 'parent' })} 
        className="fixed bottom-32 right-4 sm:right-8 z-40"
      />

      {/* Blog Section */}
      <BlogSection />
  
      {/* Signup Modal */}
      <SignupModal show={showSignupModal} onClose={handleCloseSignup} initialRole={signupRole} />

      {/* Footer */}
      <Footer />

      {/* WhatsApp Floating Button */}
      <a 
        href="https://wa.me/918978733122" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 w-14 h-14 sm:w-16 sm:h-16 bg-green-500 text-white rounded-full flex items-center justify-center shadow-xl hover:shadow-2xl hover:scale-105 transition-all z-30" 
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-8 h-8" />
      </a>
    </div>
  );
}